import { PropertyDTO } from '../general/property.dto';
import { IFileData } from 'src/app/document-add/document-upload-select/document-upload-select.component';
import { IACL } from '../acl.interface';

export const INITIAL_DOCUMENT: Document = {
    id: null,
    properties: null,
    propertiesObj: {
        ClassDescription: 'FixedTermContract',
        ContractStatus: 1,
    },
    complete: false,
    annotations: [{ properties: [], propertiesObj: {} }],
};

// export const INITIAL_DOCUMENT: Document = {
//     id: null,
//     properties: null,
//     propertiesObj: {
//         ClassDescription: 'FixedTermContract',
//         ContractStatus: 1,
//         DocumentTitle: 'TestBatch4',
//         ContractStartDate: new Date(),
//         ContractEndDate: new Date(),
//         ContractDateOfLastSignature: new Date(),
//         ContractReviewDeadlineDate: new Date('12/12/2020'),
//         ContractAgreementType: 1,
//         ContractBusinessOwner: 111,
//         ContractDepartment: 'TestDept',
//         ContractMolecules: [1, 2, 3],
//         ContractTerritories: [3, 4, 5],
//     },
//     complete: false,
//     annotations: [{ properties: [], propertiesObj: {} }],
// };

export interface Document {
    id: string;
    properties: PropertyDTO[];
    propertiesObj?: any;
    linkedDocuments?: string[];
    permissions?: string[];
    annotations?: Annotation[];
    audits?: Audit[];
    alerts?: Alert[];
    complete: boolean;
    file?: IFileData;
    objectStore?: string;
    acl?: IACL[];
    noAccess?: boolean;
}

export interface Audit {
    properties: PropertyDTO[];
    propertiesObj?: any;
}

export interface Alert {
    id: string;
    docId?: string;
    properties: PropertyDTO[];
    propertiesObj: any;
}

export enum Type {
    ClassJavaLangBoolean = 'class java.lang.Boolean',
    ClassJavaLangInteger = 'class java.lang.Integer',
    ClassJavaLangString = 'class java.lang.String',
    ClassJavaUtilDate = 'class java.util.Date',
    ClassLjavaLangString = 'class [Ljava.lang.String;',
    JavaLangString = 'java.lang.String',
}

export interface Annotation {
    properties?: PropertyDTO[];
    propertiesObj?: any;
}
